import * as vm from 'src/generated/api/vm.api';

// TODO: Нет документации на этот сервис @https://jira.jurta.kz/browse/JURTA-3419
type GetRealPropertyList = vm.paths['/api/realProperty/getRealPropertyList']['post'];
export type GetRealPropertyListParams = GetRealPropertyList['parameters']['body']['dto'];
export type GetRealPropertyListResp = GetRealPropertyList['responses']['200']['schema'];
